<template>

  <HeaderSection />

  <section id="formulario" class="p-8 bg-cover bg-no-repeat min-h-[900px]" :style="{ backgroundImage: 'url(' + require(`@/assets/formulario.png`) + ')' }">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700 Mindset text-center">

      <div class="container mx-auto p-6 max-w-3xl bg-white rounded-lg">


      <h1 class="font-bold text-center text-3xl uppercase TommyBlack">Credenciales</h1>
      <h1 class="font-bold text-center text-xl">Por favor completá el formulario para descargar su credencial</h1>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2">
            <label class="block mb-1">Ingresá tu número de documento</label>
            <Field name="documento" v-slot="{ field, errors }" v-model="formData.documento">
              <InputText v-bind="field" type="numeric"  placeholder="Documento"  class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="documento" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap items-center justify-center py-2 mt-3">
          <button type="submit" 
            class="Abo  w-full sm:w-auto px-10 py-3 mt-3 text-2xl Mindset bg-transparent border border-[#ffb700] text-[#df4753] rounded-full hover:bg-[#ffb700] shadow-lg hover:scale-110" :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>DESCARGAR QR
          </button>
        </div>

        <div class="container mx-auto py-10">
          <img class="object-contain mx-auto" src="@/assets/fdd.png" style="max-width: 200px;" />
        </div>


      </div>

      <BlockUI :blocked="isSubmitting" fullScreen />

    </Form>

  </section>

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import BlockUI from 'primevue/blockui';
import HeaderSection from './HeaderSection.vue';

import suiteService, { Acreditado } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';
import { VERIFICADO } from 'qreventos-suite/constantes';

export default defineComponent({
  components: {
    HeaderSection,
    InputText, BlockUI,
    Field, ErrorMessage, Form
  },
  created () {
    document.title = "FDD 2025";
  },
  data() {
    return {
      isSubmitting: false,
      formData: {
        documento: '',
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        documento: yup.string().required('Ingrese su documento').min(7, 'Al menos 6 números'),
      });
    }
  },
  methods: {
    async onSubmit() {
      this.isSubmitting = true;

      let acreditado:Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni="+this.formData.documento) as Acreditado;
      if(!acreditado) {
        this.isSubmitting = false;
        Swal.fire({ title: "¡Atención!",  html: "El acreditado no existe<br/>", icon: "error" });
        return;
      }

      if(acreditado.estadoAcreditado.id != VERIFICADO) {
        this.isSubmitting = false;
        Swal.fire({ title: "¡Atención!",  html: "La acreditación todavía no fue verificada<br/>", icon: "error" });
        return;
      }
			
      try {
        location.href = "https://apps.qreventos.com/credencial/getCredencial?evento=" + suiteConfig.evento + "&hash=" + acreditado.hash;
      } finally {
        this.isSubmitting = false;
      }
    }
  }, 
  async mounted() {
    if (!await suiteConfig.isEventoValido()) {
      this.isSubmitting = true;
      return;
    }    
  }
});
</script>
